module.exports = __webpack_public_path__ + "static/footer__logo-e0b15ca764345c65f528f7b10f938592.svg";